import { render, staticRenderFns } from "./GroupRowDetails.vue?vue&type=template&id=db5378e2&scoped=true"
import script from "./GroupRowDetails.vue?vue&type=script&lang=ts"
export * from "./GroupRowDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5378e2",
  null
  
)

export default component.exports